import React, { FunctionComponent } from 'react';

import { VirtualBackgroundType } from '../../../settings';
import { BackgroundOption } from './background-option';
import css from './styles.css';
import { BackgroundOptionItem } from './types';

interface BackgroundOptionsProps {
    items: BackgroundOptionItem[];
    selectedItemType: VirtualBackgroundType;
    setSelectedItemType?: (type: VirtualBackgroundType) => void;
}

const BackgroundOptions: FunctionComponent<BackgroundOptionsProps> = ({
    items,
    selectedItemType,
    setSelectedItemType,
}) => {
    return (
        <div className={css.options}>
            {items.map((item) => (
                <BackgroundOption
                    key={item.title()}
                    item={item}
                    selected={selectedItemType === item.type}
                    onClick={() => setSelectedItemType?.(item.type)}
                />
            ))}
        </div>
    );
};

export default BackgroundOptions;
